import React from 'react';
import "./Contact.css"
import emailjs from 'emailjs-com';
import { FaFacebook,FaLinkedin,FaGithub,FaMapMarkerAlt} from 'react-icons/fa';
import { HiOutlineMail ,HiPhoneIncoming} from "react-icons/hi";
const Contact = () => {
    
    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('gmail', 'template_tskc0tq', e.target, 'user_Htaz2GmhWDWFB2JJesf2x')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          e.target.reset()
      }

    return (
        <>
        <div className="contact">
            <div className="inns" style={{ backgroundImage: "url(Images/header.svg)" }}>
               <div className="inns-in">
               <h1>CONTACT ME</h1>
               </div>
            </div>
            <div className="contact-in">
                {/* start */}
                <section id="contact" className="section">
            
            <div className="asdff">
                <div className="contactInfoo">
                    <div>
                        <h2>Contact Info</h2>
                        <ul className="infoo">
                            <li style={{cursor: 'auto'}}>
                                <span className="reactIco">< FaMapMarkerAlt/></span>
                                <span> Dhaka,Bangladesh</span>
                            </li>
                            <li>
                               <a className="asa" href="mailto:mdimranulhaque.2022@gmial.com">

                               <span className="reactIco">< HiOutlineMail/> <span className="reactIcoo">Click to Mail me !</span></span>
                               

                               </a>
                            </li>
                            <li style={{cursor: 'auto'}}>
                                <span className="reactIco">< HiPhoneIncoming/></span>
                                <span> +8801771207845</span>
                            </li>
                        </ul>
                    </div>
                    <ul className="sci">

                        <li><a target="_blank"  rel="noreferrer" href="https://www.facebook.com/profile.php?id=100071106706650"><span className="reactIcooo">< FaFacebook/></span></a></li>

                        <li> <a target="_blank" rel="noreferrer"  href="https://www.linkedin.com/in/md-imranul-haque/" ><span className="reactIcooo">< FaLinkedin/></span></a> </li>

                        <li><a  target="_blank" rel="noreferrer" href="https://github.com/Imran-2021"><span className="reactIcooo">< FaGithub/></span></a></li>

                    </ul>
                </div>
                <div className="contactFormm"> 
                    <h2>Send a Message</h2>
                    <form onSubmit={sendEmail}>
                    <div className="xxxx">
                    
                        <div className="inputxx asdfff">
                            <input type="text" name="firstName" id="" required/>
                            <span >First Name</span>
                        </div>
                        <div className="inputxx asdfff">
                            <input type="text" name="lastName" id="" required/>
                            <span>Last Name</span>
                        </div>
                        <div className="inputxx asdfff">
                            <input type="text" name="email" id="" required/>
                            <span>Email Address</span>
                        </div>
                        <div className="inputxx asdfff">
                            <input type="text" name="number" id="" required/>
                            <span>Mobile Number</span>
                        </div>
                        <div className="inputxx asdffff">
                            <textarea name="message" required></textarea>
                            <span>write your message here..</span>
                        </div>
                        <div className="inputxx asdffff">
                            <input type="submit" value="send"/>
                            
                        </div>
                   
                    </div> 
                    </form>
                </div>

            </div>
        </section>
                
            </div>
        </div>
        </>
    );
};

export default Contact;